module.exports = __webpack_public_path__ + "static/media/wetsand1.cc618905.svg";